import { Component, Injector, OnInit } from '@angular/core';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, ProjectTypeCountDto } from '../../../../../shared/service-proxies/service-proxies';

@Component({
  selector: 'app-billable-employee',
  templateUrl: './billable-employee.component.html',
  styleUrls: ['./billable-employee.component.css']
})
export class BillableEmployeeComponent extends AppComponentBase implements OnInit {


    isLoaded = false;
    isDataempty = true;
    //Sets Height and width of the pie chart
    view: any[] = [600, 200];
    billableValue: number;
    NonbillableValue: number;
 
    projectTypeCountDto: ProjectTypeCountDto[] = [];
    isArabic = false;

    // options
    gradient: boolean = false;
    showLegend: boolean = false;
    showLabels: boolean = false;
    isDoughnut: boolean = false;

    projectInfo = new ProjectTypeCountDto();
    istrueValue: boolean;
    isEmptyCheck = true;
  
   
    //color scheme for billable section
    colorScheme = {
        domain: ['#1BC5BD', '#F53B57']
    };

    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy, injector: Injector) {super(injector) }

    ngOnInit(): void {
        if (abp.localization.currentLanguage.displayName == 'العربية') {
            this.isArabic = true;
        }

        this.getUserTaskListdetails();
    }

    pieChartLabel(series: any[], name: string): string {
        const item = series.filter(data => data.name === name);
        if (item.length > 0) {
            return item[0].label;
        }
        return name;
    }


    //Function for getting biilable and non-billable data
    getUserTaskListdetails() {
        console.log('OnIT');
        this._AllDashboardServiceProxy.getBillableNonBillableProject(true).subscribe(result => {
            this.projectTypeCountDto = result;
            console.log(this.projectTypeCountDto)
            this.billableValue = result[0].value;
            this.NonbillableValue = result[1].value;
            this.isLoaded = true;
            result.forEach(x => {
                if (x.value != 0) {
                    this.isEmptyCheck = false;
                }
                else {
                    this.isEmptyCheck = true;
                }
            })
         
        })
         
    }


}
